module.exports = __webpack_public_path__ + "img/Shopeelogo.da9d1799.svg";